import NotificationsPage from './Notifications';

export default NotificationsPage;
